/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResellerTenantProjectionResponse } from '../../models/reseller-tenant-projection-response';

export interface GetResellerUsers$Params {
  resellerId: string;
}

export function getResellerUsers(http: HttpClient, rootUrl: string, params: GetResellerUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerTenantProjectionResponse>> {
  const rb = new RequestBuilder(rootUrl, getResellerUsers.PATH, 'get');
  if (params) {
    rb.path('resellerId', params.resellerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResellerTenantProjectionResponse>;
    })
  );
}

getResellerUsers.PATH = '/resellers/{resellerId}/users';
